import React from 'react';
import styled from 'styled-components';
import { Typography } from '@mesa-labs/mesa-ui';
import { useOktaAuth } from '@okta/okta-react';

import { useDispatch, useSelector } from '../../redux/hooks';
import { getImpersonatedVendorId, setupCognito } from '../../redux/slices/auth';
import { ThunkActionDispatch } from 'redux-thunk';
import { useEndVendorImpersonationMutation } from '../../redux/api/facilitators';

const ImpersonationContainer = styled.div`
  align-items: center;  
  border-radius: 6px;
  border: 1px solid #122368;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  line-height: 24px;
  padding: 10px 12px;
  top: 0px;
  width: fit-content;
`;

const ImpersonationText = styled(Typography.BodyMedium)`
  align-items: center;
  color: ${(props) => props.theme.colors.White};
  cursor: pointer;
  display: flex;
  font-family: ${(props) => props.theme.fonts.inter};
  font-size: 14px;
  font-weight: 500;
  gap: 16px;
  justify-content: center;
  justify-self: center;

  &:hover {
    text-decoration: underline;
  }
`;

function Impersonation(): React.ReactElement | null {
  const dispatch = useDispatch() as ThunkActionDispatch<any>;
  const attributes = useSelector((state) => state.auth.attributes);
  const partnerId = useSelector((state) => state.auth.partnerId);

  const { oktaAuth } = useOktaAuth();

  const impersonatedVendorId = getImpersonatedVendorId(attributes);
  const [endVendorImpersonation] = useEndVendorImpersonationMutation();

  const handleEndVendorImpersonation = async () => {
    if (impersonatedVendorId) {
      await endVendorImpersonation({ id: impersonatedVendorId });
      await dispatch(setupCognito({ forceRefresh: true }));
    }
  };

  if (!partnerId || !impersonatedVendorId) {
    return null;
  }

  return (
    <ImpersonationContainer>
      <ImpersonationText onClick={handleEndVendorImpersonation}>
        End vendor impersonation
      </ImpersonationText>
    </ImpersonationContainer>
  );
}

export default Impersonation;
